var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isUserCompany ? _c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-title', {
    staticClass: "px-0"
  }, [_vm._v(" 링크 공유 ")]), _c('v-card-subtitle', {
    staticClass: "px-0"
  }, [_vm._v(" 링크를 참여자에게 공유하면 회의에 참석할 수 있습니다 ")]), _c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey lighten-5"
    }
  }, [_c('v-row', {
    staticClass: "ma-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_vm._v(" " + _vm._s(_vm.link) + " ")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('v-icon', [_vm._v("mdi-content-copy")])], 1)], 1)], 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }